import React, { useState, useEffect, memo } from 'react';
import {
    Modal, Box, Typography, Paper, CardHeader, Grid, Tooltip, TextField,
    FormControl, RadioGroup, FormControlLabel, Radio, Button, Chip,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@mui/material';
import {
    Refresh as RefreshIcon,
    CheckCircle as CheckCircleIcon,
    HourglassEmpty as HourglassEmptyIcon,
    AccessTime as AccessTimeIcon,
    Edit as EditIcon,
    Close as CloseIcon,
    Attachment as AttachmentIcon,
    Replay as ReplayIcon
} from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useSnackbar } from "../../components/SnackBar/SnackbarContext";
import configAPI from '../../api/config';
import { TicketTrackingActions } from '../../api/auth/authService';
import { useSelector } from 'react-redux';
const StatusUpdateModal = memo(({
    open,
    onClose,
    selectedTicket,
    onStatusUpdated,
    getStatusColor,
    getPriorityColor
}) => {
    const [localRemark, setLocalRemark] = useState("");
    const [selectedStatus, setSelectedStatus] = useState('');
    const [comment, setComment] = useState('');
    const [isUpdating, setIsUpdating] = useState(false);
    const { showSnackbar } = useSnackbar();
    const BASE_URL = configAPI.REACT_APP_API_BASE_URL;
    const user = useSelector((state) => state.auth?.user);
    const currentStatus = selectedTicket?.statusHistory && selectedTicket.statusHistory.length > 0
        ? selectedTicket.statusHistory[0].status
        : selectedTicket?.status || '';

    const latestStatus = selectedTicket?.statusHistory?.[0]?.status
        || selectedTicket?.status
        || 'open';

    useEffect(() => {
        if (open) {
            setSelectedStatus(latestStatus);
            setLocalRemark('');
        }
    }, [open, latestStatus]);
console.log(selectedTicket,"selectedTicket");
    const handleStatusUpdate = async () => {
        if (!selectedTicket || !selectedStatus) {
            showSnackbar('Please select a status', 'warning');
            return;
        }

        if (selectedStatus === selectedTicket.status) {
            showSnackbar('Status is already the same', 'info');
            return;
        }

        setIsUpdating(true);

        const formData = new FormData();
        formData.append('Action', 'EDIT_TICKET_TOGGLE');
        formData.append('TickeId', selectedTicket.tickeId);
        formData.append('SchoolID', selectedTicket.schoolId);
         formData.append('TicketStatus', selectedStatus);
        formData.append('Remarks', localRemark.trim());
        formData.append('ModifiedBy', user?.adminID);

        try {
            const response = await TicketTrackingActions(formData);

            if (response.success) {
                showSnackbar(`Status updated to ${selectedStatus}`, 'success');
                if (typeof onStatusUpdated === 'function') {
                    onStatusUpdated();
                }
                onClose();
                setLocalRemark('');
                setSelectedStatus('');
            } else {
                showSnackbar(response.message || 'Update failed', 'error');
            }
        } catch (err) {
            console.error(err);
            showSnackbar('Failed to update ticket', 'error');
        } finally {
            setIsUpdating(false);
        }
    };

    return (
        <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
    >
        <DialogTitle sx={{ 
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    bgcolor: 'primary.main',
                    color: 'white'
                }}>
                                    <Typography variant="h6">
                                    Update Ticket Status
                    </Typography>
                    <IconButton onClick={onClose} sx={{ color: 'white' }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                    <DialogContent dividers sx={{ pt: 3 }}>
                        {selectedTicket && (
                            <>
                                <Paper elevation={0} sx={{ p: 2, border: "1px solid", borderColor: "divider", borderRadius: 1.5, backgroundColor: "#fff" }}>
                                    <CardHeader sx={{ px: 0, py: 0.5, mb: 1, minHeight: "unset", "& .MuiCardHeader-content": { overflow: "hidden" } }}
                                        title={<Typography variant="body2" fontWeight='bold'>Ticket Information</Typography>}
                                        action={
                                            <Box display="flex" gap={0.5} flexWrap="wrap">
                                                <Chip
                                                    label={currentStatus.toUpperCase()}
                                                    color={getStatusColor(currentStatus)}
                                                    size="small"
                                                    sx={{lineHeight:'inherit'}}
                                                />
                                                <Chip label={selectedTicket.priority.toUpperCase()} color={getPriorityColor(selectedTicket.priority)} sx={{lineHeight:'inherit'}} size="small" />
                                            </Box>
                                        }
                                    />
                                    <Grid container spacing={0.5}>
                                        <Grid size={{ xs: 12 }}><Typography variant="caption" color="text.secondary">School</Typography><Typography variant="body2" noWrap>{selectedTicket.school || "—"}</Typography></Grid>
                                        <Grid size={{ xs: 12, sm: 6 }}><Typography variant="caption" color="text.secondary">Category</Typography><Typography variant="body2" noWrap>{selectedTicket.category || "—"}</Typography></Grid>
                                        <Grid size={{ xs: 12, sm: 6 }}><Typography variant="caption" color="text.secondary">Created By</Typography><Typography variant="body2" noWrap>{selectedTicket.createdBy || "—"}</Typography></Grid>
                                        <Grid size={{ xs: 12 }}><Typography variant="caption" color="text.secondary">Title</Typography>
                                            <Tooltip title={<Typography variant="body2" sx={{ p: 0.5 }}>{selectedTicket.subject}</Typography>} placement="top-start"
                                                componentsProps={{ tooltip: { sx: { backgroundColor: "#fff", color: "text.primary", boxShadow: "none", border: "1px solid", borderColor: "divider", maxWidth: 320 } } }}>
                                                <Typography variant="body2" sx={{ mt: 0.25, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer", color: "text.primary" }}>{selectedTicket.subject || "—"}</Typography>
                                            </Tooltip>
                                        </Grid>
                                        <Grid size={{ xs: 12 }}><Typography variant="caption" color="text.secondary">Description</Typography>
                                            <Tooltip title={<Typography variant="body2" sx={{ p: 0.5 }}>{selectedTicket.description}</Typography>} placement="top-start"
                                                componentsProps={{ tooltip: { sx: { backgroundColor: "#fff", color: "text.primary", boxShadow: "none", border: "1px solid", borderColor: "divider", maxWidth: 320 } } }}>
                                                <Typography variant="body2" sx={{ mt: 0.25, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer", color: "text.primary" }}>{selectedTicket.description || "—"}</Typography>
                                            </Tooltip>
                                        </Grid>
                                        <Grid size={{ xs: 12 }}>
                                            <Typography variant="caption" color="text.secondary">Attachments</Typography>
                                            <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
                                                {selectedTicket?.attachments && selectedTicket.attachments.length > 0 ? (
                                                    selectedTicket.attachments.map((filePath, index) => {
                                                        const fileUrl = `${BASE_URL}${filePath}`;
                                                        const fileName = `Attachment ${index + 1}`;

                                                        return (
                                                            <Chip
                                                                key={index}
                                                                icon={<AttachmentIcon fontSize="small" />}
                                                                label={fileName}
                                                                size="small"
                                                                variant="outlined"
                                                                clickable
                                                                component="a"
                                                                href={fileUrl}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                sx={{
                                                                    lineHeight:'inherit',
                                                                    '& .MuiChip-label': { pl: 1 },
                                                                    textDecoration: 'none',
                                                                    cursor: 'pointer',
                                                                    color: 'primary.main',
                                                                    borderColor: 'primary.main',
                                                                    '&:hover': {
                                                                        backgroundColor: 'primary.50',
                                                                        textDecoration: 'underline',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                    },
                                                                    '& .MuiChip-icon': {
                                                                        color: 'primary.main'
                                                                    }
                                                                }}
                                                            />
                                                        );
                                                    })
                                                ) : (
                                                    <Typography variant="body2" color="text.secondary" mt={0.5}>No attachments</Typography>
                                                )}
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Paper>

                                <Box mt={1}>
                                    <Typography variant="body2" gutterBottom sx={{ mb: 1 }}>Select New Status:</Typography>
                                    <FormControl fullWidth>
                                        <RadioGroup row value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}>
                                            {['open', 'progress', 'resolved', 'closed', 'reopened'].map((status) => (
                                                <FormControlLabel key={status} value={status} control={<Radio size="small" />}
                                                    label={
                                                        <Box display="flex" alignItems="center" gap={1} sx={{lineHeight:'inherit'}}>
                                                            <Chip label={status.charAt(0).toUpperCase() + status.slice(1)} color={getStatusColor(status)} sx={{lineHeight:'inherit'}} size="small"
                                                                variant={selectedStatus === status ? "filled" : "outlined"} />
                                                            {status === "reopened" && selectedTicket?.reopenedCount > 0 && (
                                                                <Typography variant="caption" color="text.secondary">
                                                                    (Previously reopened {selectedTicket.reopenedCount} times)
                                                                </Typography>
                                                            )}
                                                        </Box>
                                                    } sx={{ mr: 2, mb: 1 }} />
                                            ))}
                                        </RadioGroup>
                                    </FormControl>
                                </Box>

                                <TextField size='small'   variant="filled" className="cp-form-control input-focus" fullWidth multiline rows={1} label="Add Remark" value={localRemark} onChange={(e) => setLocalRemark(e.target.value)} />
                            </>
                        )}
                    </DialogContent>

                    <DialogActions sx={{ p: 2 }}>
                        <Button variant="contained" onClick={handleStatusUpdate}
                            disabled={!selectedStatus || isUpdating || selectedStatus === latestStatus}
                            startIcon={isUpdating ? <RefreshIcon className="spin" /> : null}
                            sx={{ boxShadow: "none", '&:hover': { boxShadow: "none" } }}>
                            {isUpdating ? "Updating..." : "Update Status"}
                        </Button>
                    </DialogActions>

          
        </Dialog>
    );
});

export default StatusUpdateModal;